var DatesFormValidator = function () {

    "use strict";
    var self = this;

    this.initialize = function () {
        this.eventDelegation();
    };

    this.eventDelegation = function () {
        $("#datesForm").formValidation(this.validator)
            .on('err.field.fv', function (e, data) {
                myApp.scrollManager.scrollToElement($(self.validator.err.container));
                myApp.formValidator.disableEqualCalendarErrorsValidation(e, data);
            })
            .on('success.field.fv', function (e, data) {
                myApp.formValidator.disableSuccessAlerts(e, data);
            })
            .on('success.form.fv', function (e) {
                let datesInput = $('input[name="data"]');
                if (!datesInput.val() || !myApp.bookingSummaryService.booking.startDate || !myApp.bookingSummaryService.booking.endDate) {
                    e.stopPropagation();
                    e.preventDefault();
                    $('[data-action="show-calendar"]').addClass('dates-error');
                    return;
                }
                if (myApp.browserStorageService.getBrowserStorageAvailable()) {
                    let numChildren = parseInt($('[data-input-sibling=children]').val());
                    let childrenAges = '';
                    for (let i = 1; i <= numChildren; i++) {
                        childrenAges += $('[data-input-sibling="children_age_' + i + '"]').val();
                        if (i !== numChildren) {
                            childrenAges += ';';
                        }
                    }

                    localStorage.setItem('adults', $('[data-input-sibling=adults]').val());
                    localStorage.setItem('children', numChildren);
                    localStorage.setItem('childrenAges', childrenAges);

                    let startDateString = '';
                    let endDateString = '';
                    if (myApp.bookingConfigurator.showDatesCalendar) {
                        let start = $('.dayContainer .flatpickr-day.startRange').attr('aria-label');
                        let end = $('.dayContainer .flatpickr-day.endRange').attr('aria-label');
                        let startDateArray = start.split("/");
                        let endDateArray = end.split("/");
                        startDateString = startDateArray[1] + '-' + startDateArray[0] + '-' + startDateArray[2];
                        endDateString = endDateArray[1] + '-' + endDateArray[0] + '-' + endDateArray[2];
                    } else {
                        let dateValue = $('[data-entity="datevalue"]').val();
                        let dateElement = $('[data-value="' + dateValue + '"][data-startdate][data-enddate]');
                        let start = dateElement.data('startdate');
                        let end = dateElement.data('enddate');
                        let startDateArray = start.split("-");
                        let endDateArray = end.split("-");
                        startDateString = startDateArray[2] + '-' + startDateArray[1] + '-' + startDateArray[0];
                        endDateString = endDateArray[2] + '-' + endDateArray[1] + '-' + endDateArray[0];
                    }
                    localStorage.setItem('start', startDateString);
                    localStorage.setItem('end', endDateString);
                }
            });
    };

    this.validator = {
        live: 'disabled',
        framework: 'bootstrap',
        err: {
            container: '#datesForm-error-messages'
        },
        fields: {
            'data': {
                excluded: false,
                validators: {
                    notEmpty: {
                        message: myApp.translator['book.dates.error']
                    }
                }
            }
        }
    };

    this.initialize();
};

export default DatesFormValidator;
